function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.43,2.483,6.9,5.011l-2.53-2.53A1.446,1.446,0,1,0,2.327,4.527l2.529,2.53L2.329,9.584a1.448,1.448,0,0,0,2.047,2.048L6.9,9.1l2.528,2.529a1.447,1.447,0,1,0,2.046-2.046L8.95,7.058l2.527-2.527A1.448,1.448,0,0,0,9.43,2.483Z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/close-2.3370493a.svg";
export { SvgComponent as ReactComponent };